import React from "react";

interface IconIProps {
  size?: string;
}

const AddIcon = ({ size = "12" }: IconIProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 6.2H12M6.2 12L6.2 0" stroke="#495A64" strokeWidth="2" />
    </svg>
  );
};
export default AddIcon;
